import React from 'react';
import PropTypes from 'prop-types';
import Image from 'react-image-resizer';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography'
import Toolbar from '@material-ui/core/Toolbar'
import UserInfo from './UserInfo'
import logo from "./AvLogo.png"

import { Base64 } from '../../modules/util'

const grey ='#a2afb9'

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 75,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    width: '100%',

  },

  appBar: {
    position: 'relative',
    height: 60,
    marginLeft: 10,
    backgroundColor: grey,
  },

  button: {
    marginLeft: 300
  },
  typography: {
    margin: 30
  },
  userEmail: {
    marginLeft: 'auto',
    margin: 30,
    fontSize: 16,
    color: 'white'
  },
  logo: {
    margin: 0,
    padding: 0
  }
});
class Header extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      mobileOpen: false,
      login: this.props.login,
      email: ''
    }
  }

  componentWillMount() {
    // セッションストレージからEmailを読み込んでdecodeする
    const encodedEmail = sessionStorage.getItem('ad_tst_ref');
    if (!encodedEmail) return;

    const email = Base64.decode(encodedEmail);
    this.setState({ email });
  }

  handleDrawerToggle = () => {
    this.setState(state => ({ mobileOpen: !state.mobileOpen }));
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <Image
              className={classes.logo}
              src={logo}
              height={60}
              width={60}
            />
            <Typography className={classes.typography} variant="title" color="inherit" noWrap>
              ITスキル適正試験
            </Typography>
            <Typography className={classes.userEmail} variant="caption">
              <UserInfo email={this.state.email} />
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  login: PropTypes.bool.isRequired,
};

export default withStyles(styles, { withTheme: true })(Header);



// WEBPACK FOOTER //
// ./src/components/general/Header.js